/*
 * @Author: Teemo Ding
 * @Date: 2021-10-27 11:35:39
 * @LastEditTime: 2022-03-21 09:02:58
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/types/common/customerDb.ts
 */
import { getI18nFromGeneral } from 'src/tools/tools';
enum EnumFieldType {
  FullName = 'FullName',
  FirstName = 'FirstName',
  LastName = 'LastName',
  PhoneNumber = 'PhoneNumber',
  AreaCodeMobileNumber = 'AreaCodeMobileNumber',
  MobileNumber = 'MobileNumber',
  AreaCode = 'AreaCode',
  DateOfBirth = 'DateOfBirth',
  Gender = 'Gender',
  Title = 'Title',
  Email = 'Email',
  CustomerID = 'CustomerID',
  RegisteredDate = 'RegisteredDate',
  RegisteredSalesChannel = 'RegisteredSalesChannel',
  AccountCreatedDate = 'AccountCreatedDate',
  TotalOrderNumber = 'TotalOrderNumber',
  TotalOrderAmount = 'TotalOrderAmount',
  AverageOrderAmount = 'AverageOrderAmount',
  LastOrderAmount = 'LastOrderAmount',
  CrossBorderName = 'CrossBorderName',
  Language = 'Language',
  CustomerRemarks = 'CustomerRemarks',
  CustomerManualTags = 'CustomerManualTags',
  CustomerAutoTags = 'CustomerAutoTags',
  ConsentAttribute = 'ConsentAttribute',
  SubscriptionStatus = 'SubscriptionStatus',
  CompanyName = 'CompanyName',
  TelephoneNumber = 'TelephoneNumber',
  // InterestedProduct = 'InterestedProduct',
}
export const nameDict = {
  [EnumFieldType.FirstName]: getI18nFromGeneral('general.customer.firstName'),
  //  getI18nFromGeneral(
  //   'general.advanceFilter.clear_all',
  // ), //, 'First name',
  [EnumFieldType.LastName]: getI18nFromGeneral('general.customer.lastName'),
  [EnumFieldType.FullName]: getI18nFromGeneral('general.customer.fullName'),
  [EnumFieldType.DateOfBirth]: getI18nFromGeneral('general.customer.dob'),
  [EnumFieldType.Gender]: getI18nFromGeneral('general.customer.gender'),
  [EnumFieldType.Title]: getI18nFromGeneral('general.customer.title'),
  [EnumFieldType.Email]: getI18nFromGeneral('general.customer.email'),
  [EnumFieldType.PhoneNumber]: getI18nFromGeneral(
    'general.customer.phoneNumber',
  ),
  [EnumFieldType.MobileNumber]: getI18nFromGeneral(
    'general.customer.mobileNumber',
  ),
  [EnumFieldType.TelephoneNumber]: getI18nFromGeneral(
    'general.customer.telephone',
  ),
  [EnumFieldType.CompanyName]: getI18nFromGeneral(
    'general.customer.companyName',
  ),
  //[EnumFieldType.AreaCodeMobileNumber]: 'Mobile number & Area Code',
};
enum ETagType {
  Manual = 'Manual',
  Auto = 'Auto',
}
export { EnumFieldType, ETagType };

export interface CustomerDatabase {
  uuid: string;
  storeUuid: string;
  name: string;
  thirdPartyLoginSetting: any;
  fullNameAutoPopulate: any;
  genders: any[];
  titles: any[];
  advancedFields: any[];
  customerNameValidationRegex: string;
  salesChannelDomains: any[];
}
